export class FactorSetValue {
    factorSetId: number;
    factorId: number;
    factorName: string;
    value: number;
	equalityMin: number;
}